import { createAction } from "../../../Common/_actions/Action";

export enum AccountStoreActionType {
  SetProductDesignSelectedProducts = 'ACCOUNT_SET_PRODUCT_DESIGN_SELECTED_PRODUCTS',
  SelectAllProductDesignSelectedProduct = 'ACCOUNT_SELECT_ALL_PRODUCT_DESIGN_SELECTED_PRODUCT',
  ClearProductDesignSelectedProduct = 'ACCOUNT_CLEAR_PRODUCT_DESIGN_SELECTED_PRODUCT',
  SetImageSelectedImages = 'ACCOUNT_SET_IMAGE_SELECTED_IMAGES',
  SelectAllImageSelectedImage = 'ACCOUNT_SELECT_ALL_IMAGE_SELECTED_IMAGE',
  ClearImageSelectedImage = 'ACCOUNT_CLEAR_IMAGE_SELECTED_IMAGE',
  SetStoreSelectedProducts = 'ACCOUNT_SET_STORE_SELECTED_PRODUCTS',
  SelectAllStoreSelectedProduct = 'ACCOUNT_SELECT_ALL_STORE_SELECTED_PRODUCT',
  ClearStoreSelectedProduct = 'ACCOUNT_CLEAR_STORE_SELECTED_PRODUCT',
}

export const SetProductDesignSelectedProducts = (ids: number[], selected: boolean) => createAction(AccountStoreActionType.SetProductDesignSelectedProducts, {
  ids: ids,
  selected: selected,
});

export const SelectAllProductDesignSelectedProduct = () => createAction(AccountStoreActionType.SelectAllProductDesignSelectedProduct);

export const ClearProductDesignSelectedProduct = () => createAction(AccountStoreActionType.ClearProductDesignSelectedProduct);

export const SetImageSelectedImages = (ids: number[], selected: boolean) => createAction(AccountStoreActionType.SetImageSelectedImages, {
  ids: ids,
  selected: selected,
});

export const SelectAllImageSelectedImage = () => createAction(AccountStoreActionType.SelectAllImageSelectedImage);

export const ClearImageSelectedImage = () => createAction(AccountStoreActionType.ClearImageSelectedImage);

export const SetStoreSelectedProducts = (ids: number[], selected: boolean) => createAction(AccountStoreActionType.SetStoreSelectedProducts, {
  ids: ids,
  selected: selected,
});

export const SelectAllStoreSelectedProduct = () => createAction(AccountStoreActionType.SelectAllStoreSelectedProduct);

export const ClearStoreSelectedProduct = () => createAction(AccountStoreActionType.ClearStoreSelectedProduct);

export type AccountStoreAction =
    ReturnType<typeof SetProductDesignSelectedProducts> |
    ReturnType<typeof SelectAllProductDesignSelectedProduct> |
    ReturnType<typeof ClearProductDesignSelectedProduct> |
    ReturnType<typeof SetImageSelectedImages> |
    ReturnType<typeof SelectAllImageSelectedImage> |
    ReturnType<typeof ClearImageSelectedImage> |
    ReturnType<typeof SetStoreSelectedProducts> |
    ReturnType<typeof SelectAllStoreSelectedProduct> |
    ReturnType<typeof ClearStoreSelectedProduct>
